import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsFooterComponent } from './settings-footer.component';

@NgModule({
    declarations: [SettingsFooterComponent],
    imports: [CommonModule, MatButtonModule, MatDividerModule, MatDialogModule, MatProgressSpinnerModule, TranslateModule],
    exports: [SettingsFooterComponent],
})
export class SettingsFooterModule {}
